const logs = {
  categories: {
    opening: ['unlock_chapa_success', 'unlock_chapa_error'],
    action: ['chapa_create_or_edit_access', 'chapa_removed_access']
  }
};
const types = {
  logs: {
    categories: {
      opening: 'opening',
      action: 'action'
    }
  }
};

export { logs, types };
